<tt-drawer-container [showToggle]="!isMobileService.isMobile()" (backdropClicked)="navShellService.close()">
  <tt-drawer
    class="tt-main-sidebar_nav"
    data-userguide="navbar"
    ttDrawerLeft
    [class.is-mobile]="isMobileService.isMobile()"
    [minWidth]="300"
    [mode]="drawerMode()"
    [opened]="sidebarOpen()"
    [resizable]="true"
    [showToggle]="!isMobileService.isMobile()"
    (toggleButtonClicked)="onSidenavToggle()">
    <shared-chapters-tree
      data-userguide="sidebar-toc"
      [readonly]="readonly"
      (nodeClicked)="isMobileService.isMobile() && navShellService.close()" />
  </tt-drawer>
  <tt-drawer-content class="tt-main-sidebar_content" id="tt-main-sidebar_content">
    <ng-content />
  </tt-drawer-content>
</tt-drawer-container>
